'use strict';
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';
import SeccionSuperior from './SeccionSuperior/SeccionSuperior.jsx';
import SeccionGrilla from './SeccionGrilla/SeccionGrilla.jsx';


class ModelosContables extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.obtenerInformacionPantalla(this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.actions.resetState();
    }

    render() {
        const { actions } = this.props;
        const { 
            redirect,
            primeraCargaPantalla,
            mostrarSpinner,
            permisosUsuario,
            datosGrillaFiltrado,
            ordenGrilla,
            columnaActivaOrdenamiento,
            checkRegistrosActivos,
            inputBuscador
        } = this.props.data;

        const error = {
            message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
            linkMessage: "Volver a mi pagina de inicio"
        };

        const errorPermisoConsulta = <GenericErrorScreen data={error} />;

        const componente = permisosUsuario.Consulta ?
                                <div>
                                    <SeccionSuperior 
                                        routeToABMModelos={actions.routeToABMModelos}
                                        checkRegistrosActivos={checkRegistrosActivos}
                                        mostrarActivos={actions.mostrarActivos}
                                        permisoAlta={permisosUsuario.Alta}
                                        inputBuscador={inputBuscador}
                                        buscarModelos={actions.buscarModelos}
                                    />

                                    <SeccionGrilla 
                                        routeToABMModelos={actions.routeToABMModelos}
                                        datosGrilla={datosGrillaFiltrado}
                                        ordenGrilla={ordenGrilla}
                                        cambiarOrden={actions.cambiarOrden}
                                        columnaActivaOrdenamiento={columnaActivaOrdenamiento}
                                        primeraCargaPantalla={primeraCargaPantalla}
                                    />
                                </div>
                            :
                                errorPermisoConsulta;


        if (redirect.shouldRedirect)
            return <Redirect to={redirect.to} push />;

        return (
            <div>
                {mostrarSpinner ?
                    <div id="loading" className="loading" />
                :
                    null
                }

                {/* Se genera esta variable "primeraCargaPantalla" para que, cuando se ingrese por primera vez a la pantalla de Modelos Contables,
                    no se visualice el mensaje de permisos por un instante antes de cargar la grilla posteriormente (en caso de que tenga efectivamente permisos de consulta minimamente)*/}
                {primeraCargaPantalla ?
                    null
                :
                    componente
                }
            </div>
        );
    }
}

export default ModelosContables;